import { FC } from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '../../../../themes/defaultTheme';
import PageViewToggleButton from './PageViewToggleButton';

const t = (key: string, options?) => translate('letterBooks', key, options);

const HeaderPageViewControls: FC<any> = () => {
  const classes = useStyles();
  return (
    <div className={classes.headerBtns}>
      <Typography variant="subtitle1" className={classes.view}>
        {t('view')}
      </Typography>
      <PageViewToggleButton />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  headerBtns: {
    display: 'flex',
    alignSelf: 'center',
    flexGrow: 1,
    justifyContent: 'flex-end',
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    margin: '0 1rem',
  },
  view: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto 10px',
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    fontWeight: 600,
  },
}));

export default HeaderPageViewControls;
